import React from 'react';

import {useThemeType} from '@gravity-ui/uikit';
import {PageConstructorProvider} from '@gravity-ui/page-constructor';
import type {Theme} from '@gravity-ui/page-constructor';

import {LANG} from '~ui/constants';
import {crossMetrika} from '~ui/services/metrika';

import {PromoPage} from '../PromoPage';

export const PromoApp: React.FC = () => {
    const theme = useThemeType() as Theme;
    return (
        <PageConstructorProvider metrika={{metrika: crossMetrika}} theme={theme}>
            <PromoPage lang={LANG} />
        </PageConstructorProvider>
    );
};
